import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Xsvg } from 'common/dist/assets/x.svg';

import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';

import styles from './index.module.css';

interface Props extends React.PropsWithChildren {
  isOpen: boolean;
  onModalClose: () => void;
  noPadding?: boolean;
  isDarkMode?: boolean;
  containerClassName?: string;
  contentClassName?: string;
  childrenContainerClassName?: string;
  topLabel?: string;
  header?: boolean;
  hideCancelButtonOnTablet?: boolean;
}

export function ModalContainer({
  isOpen,
  onModalClose,
  noPadding,
  isDarkMode,
  containerClassName,
  contentClassName,
  childrenContainerClassName,
  topLabel,
  header = true,
  hideCancelButtonOnTablet = false,
  children,
}: Props) {
  const { t } = useTranslation();

  return (
    <Modal
      open={isOpen}
      onClose={onModalClose}
      className={classnames(
        styles.modal,
        { [styles.DarkMode]: isDarkMode },
        containerClassName,
      )}
    >
      <Paper
        className={classnames(styles.paper, styles.noOutline, contentClassName)}
        elevation={0}
      >
        <Grid container>
          {header && (
            <>
              <Grid
                container
                alignItems="center"
                className={classnames(styles.labelText, styles.TopStickyBar)}
                item
                xs={9}
              >
                {topLabel && <div className={styles.TopLabel}>{topLabel}</div>}
              </Grid>
              <Grid
                item
                xs={3}
                className={classnames(
                  styles.cancelDiv,
                  styles.TopStickyBar,
                  hideCancelButtonOnTablet && styles.TabletCancelDiv,
                )}
              >
                <button className={styles.cancelButton} onClick={onModalClose}>
                  <Xsvg
                    className={styles.CloseIcon}
                    data-testid={'close-button'}
                  />
                  {topLabel ? null : t('Cancel')}
                </button>
              </Grid>
              {!isDarkMode && (
                <Grid item xs={12}>
                  <div className={styles.divider} />
                </Grid>
              )}
            </>
          )}
          <Grid
            item
            xs={12}
            className={classnames(
              { [styles.modalBodyDiv]: !noPadding },
              childrenContainerClassName,
            )}
          >
            {children}
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
}
